import EmailValidationComponent from "@components/find/EmailValidationComponent";
import BackHeader from "@components/header/BackHeader";
import styled from "@emotion/styled";
import { zodResolver } from "@hookform/resolvers/zod";
import { emailSchema } from "@libs/zod/zodVaildation";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const methods = useForm({
    resolver: zodResolver(emailSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      login_id: "",
    },
  });

  const handleBackEvent = () => {
    navigate(-1);
  };

  return (
    <FormProvider {...methods}>
      <BackHeader title="회원가입" onClick={handleBackEvent} />
      <Container>
        <EmailValidationComponent
          title="사용하실 이메일을 인증해주세요."
          fieldName="login_id"
          modalMessage="입력하신 이메일로 링크가 전송되었습니다."
          subMessage="인증 후 회원가입을 완료해주세요."
          type="signup"
        />
      </Container>
    </FormProvider>
  );
};

export default VerifyEmail;

const Container = styled.div(() => ({
  padding: "2rem",
}));
